var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAMklEQVR42mMYPGDOnNn/ScFYDXByciIKg9SysrL+HzVg1ADaGEAkRhiADkCCpGCqZEIAiVBFXjVX9RwAAAAASUVORK5CYII=";
  export default img;